"use strict";
exports.__esModule = true;
exports.CommonDateUtils = void 0;
var date_fns_1 = require("date-fns");
var date_fns_tz_1 = require("date-fns-tz");
var CommonDateUtils = /** @class */ (function () {
    function CommonDateUtils() {
    }
    CommonDateUtils.format = function (date, pattern, options) {
        if (options === void 0) { options = {}; }
        if (!date)
            return "";
        if (typeof date === "string") {
            if (options === null || options === void 0 ? void 0 : options.convertDateToDashToSlash)
                date = date.replace(/-/g, "/").replace("Z", "").replace("T", " ");
            date = new Date(date);
        }
        if (!(0, date_fns_1.isValid)(date))
            return "";
        if (options === null || options === void 0 ? void 0 : options.timeZone)
            return (0, date_fns_tz_1.formatInTimeZone)(date, options.timeZone, pattern);
        return (0, date_fns_1.format)(date, pattern);
    };
    CommonDateUtils.parse = function (str, pattern, options) {
        try {
            return (0, date_fns_1.parse)(str, pattern, new Date(), options);
        }
        catch (ex) {
            return new Date(undefined);
        }
    };
    CommonDateUtils.parseDateFromYYYYMM = function (strDate) {
        return new Date("".concat(strDate === null || strDate === void 0 ? void 0 : strDate.replace(/-/g, "/"), "/01"));
    };
    CommonDateUtils.ConvertMonthFromYYYYMM = function (strDate) {
        var d = this.parseDateFromYYYYMM(strDate);
        return this.format(d, "MMM, yyyy");
    };
    CommonDateUtils.convertDateToYYYYMM = function (date) {
        return (0, date_fns_1.format)(this.parseDate(date), "yyyy-MM");
    };
    CommonDateUtils.convertDateToYYYYMMDD = function (date) {
        return (0, date_fns_1.format)(this.parseDate(date), "yyyy-MM-dd");
    };
    CommonDateUtils.convertDateToYYYYMMDDSlash = function (date) {
        return this.format(date, this.dateFormats.Slash_YYYY_MM_DD);
    };
    CommonDateUtils.convertDateToSystemDate = function (date, includeTime) {
        if (includeTime === void 0) { includeTime = false; }
        return this.format(date, includeTime
            ? this.dateFormats.SYSTEM_DATE_TIME
            : this.dateFormats.SYSTEM_DATE);
    };
    CommonDateUtils.parseDateWithoutTimeZone = function (strDate) {
        var date = strDate;
        if (typeof strDate === "string")
            date = strDate.replace("Z", "");
        return new Date(date);
    };
    CommonDateUtils.parseDate = function (date) {
        if (typeof date === "object")
            return new Date(date);
        if (typeof date === "string")
            return new Date(date);
        return date;
    };
    CommonDateUtils.getCurrentTimezone = function () {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    };
    CommonDateUtils.getCurrentTimezoneMinutes = function () {
        return new Date().getTimezoneOffset();
    };
    CommonDateUtils.getTimezoneMinutes = function (timeZone) {
        var offset = (0, date_fns_tz_1.getTimezoneOffset)(timeZone);
        if (!offset)
            return offset;
        return offset / 1000 / 60;
    };
    /** It will do targetTimezone - currentTimezone. You can override currentTimezone */
    CommonDateUtils.getTimezoneDifferenceMinutes = function (targetTimezone, currentTimezone) {
        if (!currentTimezone)
            currentTimezone = this.getCurrentTimezone();
        return (this.getTimezoneMinutes(targetTimezone) -
            this.getTimezoneMinutes(currentTimezone));
    };
    CommonDateUtils.getPreviousMonthYYYYMM = function () {
        var month = (0, date_fns_1.format)((0, date_fns_1.subMonths)(new Date(), 1), "yyyy-MM");
        return month;
    };
    CommonDateUtils.getNextWeekday = function (date) {
        if (date === void 0) { date = new Date(); }
        while ((0, date_fns_1.isWeekend)(date)) {
            date = (0, date_fns_1.addDays)(date, 1);
        }
        return date;
    };
    CommonDateUtils.getNextHHMM = function (io) {
        var currentDate = io.AsOfDate || new Date();
        var splitted = io.HHMM.split(":");
        var hours = Number(splitted[0]);
        var minutes = Number(splitted[1]);
        var nextHHMM = (0, date_fns_1.setHours)((0, date_fns_1.setMinutes)(currentDate, minutes), hours);
        if ((0, date_fns_1.isAfter)(currentDate, nextHHMM)) {
            nextHHMM = (0, date_fns_1.addDays)(nextHHMM, 1);
        }
        var day = (0, date_fns_1.getDay)(nextHHMM);
        if (io.SkipWeekends) {
            if (day === 6) {
                // If it's Saturday
                nextHHMM = (0, date_fns_1.addDays)(nextHHMM, 2); // Move to Monday
            }
            else if (day === 0) {
                // If it's Sunday
                nextHHMM = (0, date_fns_1.addDays)(nextHHMM, 1); // Move to Monday
            }
        }
        return nextHHMM;
    };
    CommonDateUtils.dateFormats = {
        SYSTEM_DATE: "MM/dd/yyyy",
        SYSTEM_DATE_TIME: "MM/dd/yyyy HH:mm:ss",
        Slash_YYYY_MM_DD: "yyyy/MM/dd",
        Slash_YYYY_MM_DD_HH_MM: "yyyy/MM/dd HH:mm"
    };
    return CommonDateUtils;
}());
exports.CommonDateUtils = CommonDateUtils;
//# sourceMappingURL=CommonDateUtils.js.map